import React from 'react';
import SearchBar from './SearchBar';
import "./home.css"
import Cards from './Cards';
import Head from '../Head';


const Home = () => {
  return (
    <main>
      <Head title="Home" />
      <SearchBar />
      {/* <Featured /> */}
      <Cards/>
    </main>
  );
};

export default Home;